import { IConfig } from "../interfaces/config";
import { log } from "./logger";

export let config: IConfig;

export const GetApplicationConfigurations = async () => {
    await fetch(`./app-config.json`)
        .then(response => response.json())
        .then(jsonResponse => {
            if (jsonResponse != null) {
                log.info(`Received Configurations`)
                console.info(jsonResponse)
                config = jsonResponse;
            }
            else {
                log.error(`app-config.json file is empty`)
            }
        })
}